import { Injectable } from '@angular/core';
import { ParametroValor } from '@tivic-team/manager-ts/dist/grl';
import { ParametroController } from 'app/controllers/grl/parametro.controller';
import { ParametroDTO } from 'app/model/dtos/grl/parametro.dto';
import { LoaderService } from 'app/services/loader.service';

@Injectable({
    providedIn: 'root'
})
export class ParametroService {

    constructor(
        private _loaderService: LoaderService,
        private _parametrosController: ParametroController
    ) { }

    async initParams():Promise<any[]>{
        try{return await this._parametrosController.initParams();}
        catch(error){return [];}
    }

    async getAll():Promise<any[]>{
        try{return await this._parametrosController.getAll();}
        catch(error){return [];}
    }

    async getMob(): Promise<Array<ParametroDTO>> {
        this._loaderService.show();
        return await this._parametrosController.getMob().finally(() => this._loaderService.hide());
    }

    async getNaoCategorizados(categorizados: string[]): Promise<Array<ParametroDTO>> {
        this._loaderService.show();
        return await this._parametrosController.getNaoCategorizados(categorizados).finally(() => this._loaderService.hide());
    }

    async getParametroOpcoes(nmParametro: string): Promise<Array<any>> {
        this._loaderService.show();
        return await this._parametrosController.getOpcoes(nmParametro).finally(() => this._loaderService.hide());
    }

    async setValores(valores: ParametroValor[]): Promise<any> {
        this._loaderService.show();
        return await this._parametrosController.setValores(valores).finally(() => this._loaderService.hide());
    }

    async getImg(nmParametro: string): Promise<Array<string>> {
        this._loaderService.show();
        return await this._parametrosController.getImg(nmParametro).finally(() => this._loaderService.hide());
    }

    async getByNome(nmParametro: string): Promise<ParametroValor> {
        this._loaderService.show();
        return await this._parametrosController.getByNome(nmParametro).finally(() => this._loaderService.hide());
    }
}
